import React, {useState, useEffect} from 'react';
import {useStore} from 'effector-react';
import languageSelection from '../globals/language-selection';
import metamask from '../globals/metamask';
import demoState from '../globals/demo-usage';
import isMobile from '../lib/helpers/detect-mobile';
import ModalForm from './modal-form';
import Header from './Header';
import Menu from './menu';
import LanguageSelectionScreen from './language-selection-screen';
import WalletSelectionScreen from './wallet-selection-screen';
import WalletLogoutForm from './wallet-logout-form';

export default function Layout(props) {
    const [open, setOpen] = useState(false),
        languageSelectionVisible = useStore(languageSelection.$visible),
        walletSelectionVisible = useStore(metamask.$walletSelectionVisible),
        walletLogoutFormVisible = useStore(metamask.$logoutFormVisible),
        metamaskInstalled = useStore(metamask.$installed),
        search = props.location.search.split(''),
        isMetamaskMobile = metamaskInstalled && isMobile;
    let langSelection, walletLogoutForm, walletSelection;

    useEffect(() => {
        demoState.init.setDemo(search[6] === '1');
        languageSelection.resetScroll();
    });

    if (languageSelectionVisible) {
        langSelection = <LanguageSelectionScreen {...props} />;
    }

    if (walletSelectionVisible && !isMetamaskMobile) {
        walletSelection = <WalletSelectionScreen {...props} />;
    }

    if (walletLogoutFormVisible && (!isMobile || isMetamaskMobile)) {
        walletLogoutForm = <WalletLogoutForm {...props} />;
    }

    return (
        <>
            {langSelection}
            {walletSelection}
            <ModalForm {...props.pageContext} />
            <Header oldState={props.oldState} toggleIcon={true} {...props.pageContext} setOpen={setOpen} />
            {walletLogoutForm}
            <Menu
                {...props.pageContext}
                location={props.location}
                open={open}
                setOpen={setOpen}
                {...props.menuProps} />
        </>
    );
}
